import { createSlice } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  ARCHIVE: [],
  totalCount: 0,
};

const slice = createSlice({
  name: "ARCHIVE",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getArchiveUserList.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getArchiveUserList.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      ARCHIVE: payload,
      totalCount: payload.total_record_count || 0, 
    }));
    builder.addCase(Act.getArchiveUserList.rejected, (state, action) => ({
      ...state,
      loading: false,
      ARCHIVE: [],
      totalCount: 0,
    }));
    builder.addCase(Act.removeArchiveUser.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.removeArchiveUser.fulfilled, (state) => ({
      ...state,
      loading: false,
    }));
    builder.addCase(Act.removeArchiveUser.rejected, (state) => ({
      ...state,
      loading: false,
    }));
  },
});

export default slice;